import ShowMapWidthLine from 'components/detailPages/ShowMapsWithLine';
import React from 'react';

function DetailPages() {
  return (
    <>
      <ShowMapWidthLine />
    </>
  );
}

export default DetailPages;
